/* eslint-disable no-case-declarations */
import React, { useEffect, useState } from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import useViewPort from "../../../hook/useViewPort";
import { Link, ResponsiveImage } from "@quintype/components";
//import useJWthumbnails from "../../../hook/useJWthumbnails";
import { Paywall } from "../../../arrow/components/Rows/Paywall";
import { createBrowserHistory, createMemoryHistory } from "history";
import JWaudio from "../../atoms/audio-video-players/jw-player/jwplayer-resume/jw-audio";
import JWplayerResumeVideo from "../../atoms/audio-video-players/jw-player/jwplayer-resume";
import "./only-video-story.m.css";
import { getCollections } from "../../../../api/utils";
import SocialShare from "../social-share";

const getElementType = (element) => element.subtype || element.type || "";
const GetVideoElement = ({story, hasAccess}) => {
  const elements = story.cards.flatMap((card) => card["story-elements"]);
  const element = elements.find((elm) => elm.type === "jsembed") || {};
  const storyAttributes =
    (story.metadata["story-attributes"] &&
      story.metadata["story-attributes"].storytype &&
      story.metadata["story-attributes"].storytype[0]) ||
    "";
  const [elementModified, setEmentModified] = useState({});
  const [audios, setAudios] = useState(false);
  const [jWplayer, setJWplayer] = useState(false);
  const [shouldReload, setShouldReload] = useState(false);
  const [videoObject, setVideoObject] = useState({});
  const [isHovered, setIsHovered] = useState(false);
  const [storyContentType, setStoryContentType] = useState("video");
  const [storySeriesName, setStorySeriesName] = useState("");
  const [storySeriesLink, setStorySeriesLink] = useState("");
  let history;

  const qtConfigSections = useSelector((state) => get(state, ["qt", "config", "sections"], {}));
  const getSectionHierarchyData = (sectionId, sections) => {
    const hierarchy = [];

    const traverse = (id) => {
      const current = sections.find(sec => sec.id === id);
      if (!current) return;

      const collectionSlug = current?.collection?.slug || '';
      const sectionSlug = current?.slug || '';

      hierarchy.unshift({
        collectionSlug,
        sectionSlug
      });

      if (current["parent-id"]) {
        traverse(current["parent-id"]);
      }
    };

    traverse(sectionId);

    const hasLammas = hierarchy.some(
      item => item.collectionSlug.toLowerCase() === "lammas" || item.sectionSlug.toLowerCase() === "lammas"
    );

    const filteredHierarchy = hierarchy.filter(
      item => item.collectionSlug.toLowerCase() !== "lammas" && item.sectionSlug.toLowerCase() !== "lammas"
    );

    return {
      filteredHierarchy,
      hasLammas
    };
  };

  const getTopMostSectionId = (sectionId, sections) => {
    const current = sections.find(sec => sec.id === sectionId);

    if (!current) return null;
    if (!current["parent-id"]) return current.slug;

    return getTopMostSectionId(current["parent-id"], sections);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const sectionId = story?.sections?.[0]?.id || null;
        const { filteredHierarchy, hasLammas } = getSectionHierarchyData(sectionId, qtConfigSections);

        if (filteredHierarchy.length > 0) {
          const topMostSection = filteredHierarchy[0];
          const topMostCollectionData = await getCollections(topMostSection.collectionSlug || topMostSection.sectionSlug);
          
          const contentTypeKey = topMostCollectionData?.metadata?.["content-type"]?.[0]?.key?.toLowerCase() || null;
          const seriesContentTypeVal = topMostCollectionData?.["name"] || null;
          
          let path = filteredHierarchy[0].sectionSlug;
          if (hasLammas) path = `lammas/${path}`;

          setStoryContentType(contentTypeKey);
          setStorySeriesName(seriesContentTypeVal);
          setStorySeriesLink(path);
        }
      } catch (error) {
        console.error("Error fetching topmost collection data:", error);
      }
    };

    fetchData();
  }, []);

  if (typeof window !== "undefined") {
    history = createBrowserHistory(); // Safe to use in browser
  } else {
    history = createMemoryHistory(); // Use for SSR
  }
  const goPrevPage = () => {
    if (typeof window !== "undefined") {
      if (document.referrer && document.referrer.includes(window.location.host)) {
        history.back();
      } else if (storySeriesLink) {
        window.location.href = `/${storySeriesLink}`;
      } else {
        window.location.href = "/";
      }
    }
  };
  const handleDataFromChild = (data) => {
    if (data) {
      setShouldReload(true);
    }
  };
  useEffect(() => {
    if (shouldReload) {
      history.back();
    }
  }, [shouldReload]);

  function jwplayerFileUrl(playerUrl) {
    const match = playerUrl.match(/https:\/\/cdn\.jwplayer\.com\/players\/([A-Za-z0-9]+)-([A-Za-z0-9]+)\.html/);
    if (match) {
      const videoId = match[1]; // Extract video ID (e.g., HIM68SUM)
      const libraryId = match[2]; // Extract player key (e.g., gDBTQBre)
      return { videoId, libraryId };
    } else {
      return null;
    }
  }

  useEffect(() => {
    // Function to decode the 'embed-js' and extract the URL
    const decodeAndAddUrl = () => {
      if (typeof window === "undefined") {
        return null;
      } else if (element["embed-js"]) {
        const decodedString = window.atob(element["embed-js"]);
        const urlMatch = decodedString.match(/src="([^"]+)"/);
        const url = urlMatch ? urlMatch[1] : decodedString;
        if (url.includes("https://stream.dei.fi:8443")) {
          setAudios(true);
        } else if (url.includes("https://cdn.jwplayer.com")) {
          setJWplayer(true);
          const { videoId, libraryId } = jwplayerFileUrl(url);
          const singleVideoFile = `https://cdn.jwplayer.com/v2/media/${videoId}`;
          setVideoObject({ singleVideoFile, libraryId, videoId });
        }
        const updatedElement = {
          ...element,
          url: url,
        };
        setEmentModified(updatedElement);
      }
    };
    decodeAndAddUrl();
  }, [element]);
  let elementType = getElementType(element);
  if (elementType === "image-gallery") {
    elementType = element.metadata.type;
  }
  const storyElementId = get(element, ["id"]);
  const { viewports } = useViewPort();
  const isStoryBehindPaywall = story.access === "subscription" && hasAccess === false;// original
  //const isStoryBehindPaywall = story.access === "subscription" || (story.access === "login" && !hasAccess); //for testing
  // following is used only if video/audio preview thumbnail imaes are needed.
  /*const { thumbnails, loading, error } = useJWthumbnails(videoObject.videoId && videoObject.videoId);
  const sortedThumbnails =
    thumbnails.length >= 1 && thumbnails.sort((a, b) => new Date(b.last_modified) - new Date(a.last_modified));
  const movingThumbnails =
    thumbnails.length >= 1 && sortedThumbnails.find((moving) => moving.thumbnail_type === "video");
  const staticThumbnails =
    thumbnails.length >= 1 && sortedThumbnails.find((moving) => moving.thumbnail_type === "static");*/

  const defaultImage = useSelector((state) => get(state, ["qt", "config"]));
  const defaultImgState = get(defaultImage, ["publisher-attributes", "defaultImageKey"], "");
 // hoverMotionThumbnail function is used only if video/audio preview thumbnail imaes are needed.
  /*const hoverMotionThumbnail = () => {
    return (
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{ width: "auto", height: "600px", overflow: "hidden", borderRadius: "8px" }}
      >
        {staticThumbnails?.delivery_url || movingThumbnails?.delivery_url ? (
          isHovered ? (
            movingThumbnails?.delivery_url ? (
              <video
                src={movingThumbnails?.delivery_url}
                autoPlay
                loop
                muted
                playsInline
                style={{ width: "100%", height: "100%", borderRadius: "8px" }}
              />
            ) : (
              <img src={staticThumbnails?.delivery_url} alt={`${staticThumbnails.thumbnail_type} thumbnail`} />
            )
          ) : (
            <img src={staticThumbnails?.delivery_url} alt={`${staticThumbnails?.thumbnail_type} thumbnail`} />
          )
        ) : (
          <figure className="story-grid-item-image">
            <ResponsiveImage
              slug={defaultImgState}
              aspectRatio={[16, 9]}
              defaultWidth={480}
              widths={[250, 480, 640]}
              sizes="(max-width: 500px) 98vw, (max-width: 768px) 48vw, 23vw"
              imgParams={{ auto: ["format", "compress"] }}
            />
          </figure>
        )}
      </div>
    );
  };*/
  const hoverMotionThumbnail = () => {
    return (
      <figure className="story-grid-item-image">
        <ResponsiveImage
          slug={story["hero-image-s3-key"]}
          aspectRatio={[16, 9]}
          defaultWidth={480}
          widths={[250, 480, 640]}
          imgParams={{ auto: ["format", "compress"] }}
          alt={story.headline}
        />
      </figure>
    );
  };

  return (
    <div className={viewports ? viewports : ""}>
      {jWplayer ? (
        isStoryBehindPaywall ? (
          <div styleName="video-container-wrapper thumbnails">
            {hoverMotionThumbnail()}
            <div styleName="video-paywall-overlay">
              <Paywall />
            </div>
          </div>
        ) : (
          <div styleName="video-container-wrapper">
            <div styleName="icons-wrapper">
              <div onClick={goPrevPage} styleName="back-arrow">
                <i class="ri-arrow-left-line"></i>
              </div>

              <div styleName="share-dtl" href="/">
                <SocialShare url={story.url} defaultText="" btnStyle="big"/>
              </div>
            </div>
            <div styleName="video-container">
            {storyContentType === "audio" ? (
                <JWaudio
                  videoObject={videoObject}
                  sendDataToParent={handleDataFromChild}
                  uniqueId={story.id}
                  storyAttributes={storyContentType}
                  storyObj={story}
                />
              ) : (
                <JWplayerResumeVideo
                  videoObject={videoObject}
                  sendDataToParent={handleDataFromChild}
                  uniqueId={story.id}
                  storyAttributes={storyContentType}
                  storyObj={story}
                />
              )}
            </div>
            <div styleName="story-content-wrapper">
              <h1>
                <Link href={`/${storySeriesLink}`}>
                  {storySeriesName}&nbsp;&nbsp;
                </Link>

                <div styleName="back-arrow">
                  <Link href={`/${storySeriesLink}`}>
                    <i class="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </h1>
              <h2>{story.headline}</h2>
              <p>{story.subheadline}</p>
            </div>
          </div>
        )
      ) : (
        <Link href="/">
          <div styleName="other-container-wrapper">
            {<h2>Loading..</h2>}
            <div styleName="back-arrow-loading">
              {" "}
              <i class="ri-arrow-left-line"></i>
            </div>
          </div>
        </Link>
      )}
    </div>
  );
};

const OnlyVideoStory = ({ story,hasAccess }) => {
  return <div><GetVideoElement story={story} hasAccess={hasAccess}/></div>;
};
OnlyVideoStory.propTypes = {
  story: PropTypes.object,
  hasAccess: PropTypes.bool,
};
export default OnlyVideoStory;
